<template>
  <EventDetailPage :event="event" />
</template>

<script setup>
const { $cmsApi } = useNuxtApp();

const route = useRoute();
const config = useRuntimeConfig();

const { data, error } = await useAsyncData(async () => {
  const previewQuery = route.query.preview
    ? `?preview=${route.query.preview}`
    : '';
  const url = `/events/${route.params.slug}${previewQuery}`;
  const event = await $cmsApi.get(url);

  return { event };
});

if (error.value) {
  throw createError({ statusCode: 404, message: 'Page not found' });
}

const event = data.value?.event || {};

useHead({
  title: event.title_tag || event.metaData?.title || event.title,
  meta: [
    {
      key: 'description',
      name: 'description',
      content: event.metaData?.description || event.description,
    },
    {
      key: 'og:title',
      property: 'og:title',
      content: event.metaData?.title || event.title,
    },
    {
      key: 'og:description',
      property: 'og:description',
      content: event.metaData?.description || event.description,
    },
    {
      key: 'og:url',
      property: 'og:url',
      content: `${config.public.hostUrl}${route.path}`,
    },
    { key: 'og:image', property: 'og:image', content: event.image },
    { key: 'og:type', property: 'og:type', content: 'event' },
    ...(event.metaData?.keywords.length
      ? [
          {
            key: 'keywords',
            name: 'keywords',
            content: event.metaData.keywords,
          },
        ]
      : []),
  ].filter((x) => x.content),
});
</script>
